module.exports = __webpack_public_path__ + "01_veryshort_black.9a4827b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_veryshort_black.png
// module id = pp9M
// module chunks = 0